// extracted by mini-css-extract-plugin
export var cell = "CompareTable-module--cell--ef8ef";
export var check = "CompareTable-module--check--ab57a";
export var dash = "CompareTable-module--dash--0e926";
export var description = "CompareTable-module--description--a1a47";
export var header = "CompareTable-module--header--5e9ad";
export var highlight = "CompareTable-module--highlight--e845e";
export var iconColor = "CompareTable-module--iconColor--4f687";
export var table = "CompareTable-module--table--61dc3";